// extracted by mini-css-extract-plugin
module.exports = {"submit-button":"submit-button-f82782c44906d6e0c4fc60e24b28ae2b","goods-form-detail":"goods-form-detail-914973843880c2e0978cb804decaaba2"};